/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createStepsIndicatorStyles = makeStyles(theme => ({
  root: {},
  item: {
    flex: '0 1 auto',
    minWidth: '4px',
    borderRadius: '2px',
    backgroundColor: theme.palette.primary.main,
    opacity: 0.2,
    height: '4px',
    width: '16px',
    marginLeft: '8px',
    transition: 'width .2s linear, opacity .2s linear',
    '&:first-child': {
      marginLeft: 0,
    },
  },
  activeItem: {
    width: '40px',
    flex: '0 0 auto',
    opacity: 1,
  },
  itemsList: {
    display: 'flex',
    flexWrap: 'nowrap',
  },
  stepsLabel: {
    textAlign: 'left',
    color: theme.palette.text.primary,
    fontSize: '16px',
    lineHeight: '22px',
    marginTop: '20px',
  },
}));
